import { SVGProps } from "react";

export default function MenuIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 13, width = 12, fill = "#545454", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M10.5 3.125H1.5C1.295 3.125 1.125 2.955 1.125 2.75C1.125 2.545 1.295 2.375 1.5 2.375H10.5C10.705 2.375 10.875 2.545 10.875 2.75C10.875 2.955 10.705 3.125 10.5 3.125Z"
        fill={fill}
      />
      <path
        d="M10.5 5.625H1.5C1.295 5.625 1.125 5.455 1.125 5.25C1.125 5.045 1.295 4.875 1.5 4.875H10.5C10.705 4.875 10.875 5.045 10.875 5.25C10.875 5.455 10.705 5.625 10.5 5.625Z"
        fill={fill}
      />
      <path
        d="M10.5 8.125H1.5C1.295 8.125 1.125 7.955 1.125 7.75C1.125 7.545 1.295 7.375 1.5 7.375H10.5C10.705 7.375 10.875 7.545 10.875 7.75C10.875 7.955 10.705 8.125 10.5 8.125Z"
        fill={fill}
      />
      <path
        d="M10.5 10.625H1.5C1.295 10.625 1.125 10.455 1.125 10.25C1.125 10.045 1.295 9.875 1.5 9.875H10.5C10.705 9.875 10.875 10.045 10.875 10.25C10.875 10.455 10.705 10.625 10.5 10.625Z"
        fill={fill}
      />
    </svg>
  );
}
